"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareTransaction = exports.getEstimatedFees = exports.calculateFees = void 0;
const cache_1 = require("@ledgerhq/live-network/cache");
const logs_1 = require("@ledgerhq/logs");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const live_env_1 = require("@ledgerhq/live-env");
const Cosmos_1 = require("./api/Cosmos");
const chain_1 = __importDefault(require("./chain/chain"));
const js_buildTransaction_1 = require("./js-buildTransaction");
const logic_1 = require("./logic");
exports.calculateFees = (0, cache_1.makeLRUCache)(({ account, transaction, }) => __awaiter(void 0, void 0, void 0, function* () {
    return yield (0, exports.getEstimatedFees)(account, transaction);
}), ({ account, transaction }) => `${account.id}_${account.currency.id}_${transaction.amount.toString()}_${transaction.recipient}_${String(transaction.useAllAmount)}_${transaction.mode}_${transaction.validators
    ? transaction.validators.map(v => `${v.address}-${v.amount}`).join("_")
    : ""}_${transaction.memo ? transaction.memo.toString() : ""}_${transaction.sourceValidator ? transaction.sourceValidator : ""}`, {
    ttl: 1000 * 60, // 60 sec
});
const getEstimatedFees = (account, transaction) => __awaiter(void 0, void 0, void 0, function* () {
    const cosmosCurrency = (0, chain_1.default)(account.currency.id);
    let estimatedGas = new bignumber_js_1.default(cosmosCurrency.defaultGas);
    const cosmosAPI = new Cosmos_1.CosmosAPI(account.currency.id);
    const unsignedPayload = yield (0, js_buildTransaction_1.buildUnsignedPayloadTransaction)(account, transaction);
    if (unsignedPayload && unsignedPayload.length > 0) {
        const signature = new Uint8Array(Buffer.from(account.seedIdentifier, "hex"));
        // see https://github.com/cosmos/cosmjs/blob/main/packages/proto-signing/src/pubkey.spec.ts
        const prefix = new Uint8Array([10, 33]);
        const pubkey = {
            typeUrl: "/cosmos.crypto.secp256k1.PubKey",
            value: new Uint8Array([...prefix, ...signature]),
        };
        const tx_bytes = yield (0, js_buildTransaction_1.postBuildUnsignedPayloadTransaction)(account, transaction, pubkey, unsignedPayload, signature);
        try {
            const gasUsed = yield cosmosAPI.simulate(tx_bytes);
            estimatedGas = gasUsed
                .multipliedBy(new bignumber_js_1.default((0, live_env_1.getEnv)("COSMOS_GAS_AMPLIFIER")))
                .integerValue(bignumber_js_1.default.ROUND_CEIL);
        }
        catch (e) {
            (0, logs_1.log)("cosmos/simulate", "failed to estimate gas usage during tx simulation", {
                e,
            });
        }
    }
    const estimatedFees = estimatedGas
        .times(cosmosCurrency.minGasPrice)
        .integerValue(bignumber_js_1.default.ROUND_CEIL);
    return { estimatedFees, estimatedGas };
});
exports.getEstimatedFees = getEstimatedFees;
const prepareTransaction = (account, transaction) => __awaiter(void 0, void 0, void 0, function* () {
    let memo = transaction.memo;
    let amount = transaction.amount;
    if (transaction.mode !== "send" && !transaction.memo) {
        memo = "Ledger Live";
    }
    const { estimatedFees, estimatedGas } = yield (0, exports.calculateFees)({
        account,
        transaction: Object.assign(Object.assign({}, transaction), { amount: transaction.useAllAmount
                ? account.spendableBalance.minus(new bignumber_js_1.default(2500))
                : amount, memo }),
    });
    if (transaction.useAllAmount) {
        amount = (0, logic_1.getMaxEstimatedBalance)(account, estimatedFees);
    }
    if (transaction.memo !== memo ||
        !estimatedFees.eq(transaction.fees || new bignumber_js_1.default(0)) ||
        !estimatedGas.eq(transaction.gas || new bignumber_js_1.default(0)) ||
        !amount.eq(transaction.amount)) {
        return Object.assign(Object.assign({}, transaction), { memo, fees: estimatedFees, gas: estimatedGas, amount });
    }
    return transaction;
});
exports.prepareTransaction = prepareTransaction;
exports.default = exports.prepareTransaction;
//# sourceMappingURL=js-prepareTransaction.js.map